<script>
import TimeCounter from "../atoms/TimeCounter.vue";
import ClockActionButton from "../atoms/ClockActionButton.vue";
import ClockActionLabel from "../atoms/ClockActionLabel.vue";
import StatusAwareComponent from "../StatusAwareComponent.vue";

export default {
  name: "ClockActionPanel",
  components: {ClockActionLabel, ClockActionButton, TimeCounter},
  extends: StatusAwareComponent,
}
</script>

<template>
  <div class="min-width">
    <div class="d-flex flex-column gap-4 justify-content-around align-items-center">
      <time-counter :status="status" :time="time" class="label clock text-gray-500 mb-0"/>
      <clock-action-button :status="status" v-on="$listeners"/>
      <clock-action-label :status="status"/>
    </div>
  </div>
</template>

<style scoped>
@media (min-width: 575px) {
  .min-width {
    min-width: 320px;
  }
}
.clock {
  font-size: 32px;
}
</style>
